import { SelectOption } from "../common/components/form/Select";

export enum CountryCode {
    SINGAPORE = "SG",
    CHINA = "CN",
    UNITED_STATES = "US",
    AUSTRALIA = "AU",
    BRAZIL = "BR",
    BELGIUM = "BE",
    CANADA = "CA",
    FRANCE = "FR",
    GERMANY = "DE",
    HONG_KONG_SAR = "HK",
    INDIA = "IN",
    INDONESIA = "ID",
    IRELAND = "IE",
    ITALY = "IT",
    JAPAN = "JP",
    LUXEMBOURG = "LU",
    MALAYSIA = "MY",
    NEW_ZEALAND = "NZ",
    PHILIPPINES = "PH",
    POLAND = "PL",
    SOUTH_AFRICA = "ZA",
    SOUTH_KOREA = "KR",
    SPAIN = "ES",
    SWEDEN = "SE",
    SWITZERLAND = "CH",
    THAILAND = "TH",
    UNITED_ARAB_EMIRATES = "AE",
    UNITED_KINGDOM = "GB",
    VIETNAM = "VN",
}

export const CountryCodeOptions: SelectOption[] = [
    {
        value: CountryCode.SINGAPORE,
        label: "Singapore",
    },
    {
        value: CountryCode.CHINA,
        label: "China",
    },
    {
        value: CountryCode.UNITED_STATES,
        label: "United States",
    },
    {
        value: CountryCode.AUSTRALIA,
        label: "Australia",
    },
    {
        value: CountryCode.BRAZIL,
        label: "Brazil",
    },
    {
        value: CountryCode.BELGIUM,
        label: "Belgium",
    },
    {
        value: CountryCode.CANADA,
        label: "Canada",
    },
    {
        value: CountryCode.FRANCE,
        label: "France",
    },
    {
        value: CountryCode.GERMANY,
        label: "Germany",
    },
    {
        value: CountryCode.HONG_KONG_SAR,
        label: "Hong Kong SAR",
    },
    {
        value: CountryCode.INDIA,
        label: "India",
    },
    {
        value: CountryCode.INDONESIA,
        label: "Indonesia",
    },
    {
        value: CountryCode.IRELAND,
        label: "Ireland",
    },
    {
        value: CountryCode.ITALY,
        label: "Italy",
    },
    {
        value: CountryCode.JAPAN,
        label: "Japan",
    },
    {
        value: CountryCode.LUXEMBOURG,
        label: "Luxembourg",
    },
    {
        value: CountryCode.MALAYSIA,
        label: "Malaysia",
    },
    {
        value: CountryCode.NEW_ZEALAND,
        label: "New Zealand",
    },
    {
        value: CountryCode.PHILIPPINES,
        label: "Philippines",
    },
    {
        value: CountryCode.POLAND,
        label: "Poland",
    },
    {
        value: CountryCode.SOUTH_AFRICA,
        label: "South Africa",
    },
    {
        value: CountryCode.SOUTH_KOREA,
        label: "South Korea",
    },
    {
        value: CountryCode.SPAIN,
        label: "Spain",
    },
    {
        value: CountryCode.SWEDEN,
        label: "Sweden",
    },
    {
        value: CountryCode.SWITZERLAND,
        label: "Switzerland",
    },
    {
        value: CountryCode.THAILAND,
        label: "Thailand",
    },
    {
        value: CountryCode.UNITED_ARAB_EMIRATES,
        label: "United Arab Emirates",
    },
    {
        value: CountryCode.UNITED_KINGDOM,
        label: "United Kingdom",
    },
    {
        value: CountryCode.VIETNAM,
        label: "Vietnam",
    },
];

